var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"home-page-numbers-section"},[_c('v-container',[_c('div',{staticClass:"text-h4 mc-font text-center mt-16"},[_c('strong',[_vm._v(_vm._s(_vm.$t('weHandleALotOfBooks')))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }